document.addEventListener("DOMContentLoaded", function () {
  // 检查是否是移动设备，移动设备上保持点击功能
  if (
    !navigator.userAgent.match(
      /Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|CrMo\/|Opera Mobi|Tablet|iPad/i
    )
  ) {
    // 获取所有下拉菜单
    const menuItems = document.querySelectorAll("header-menu");

    menuItems.forEach((menuItem) => {
      const details = menuItem.querySelector("details");
      const summary = details?.querySelector("summary");
      const submenu = details?.querySelector(
        ".header__submenu, .mega-menu__content"
      );

      if (!details || !summary || !submenu) return;

      // 鼠标进入菜单项时打开下拉菜单
      menuItem.addEventListener("mouseenter", () => {
        details.setAttribute("open", true);
        summary.setAttribute("aria-expanded", true);
      });

      // 鼠标离开菜单项时关闭下拉菜单
      menuItem.addEventListener("mouseleave", () => {
        // 添加短暂延迟，避免菜单闪烁
        setTimeout(() => {
          if (!menuItem.matches(":hover")) {
            details.removeAttribute("open");
            summary.setAttribute("aria-expanded", false);
          }
        }, 50);
      });

      // 防止点击菜单标题触发折叠/展开
      summary.addEventListener("click", (e) => {
        // 导航到链接而不是切换dropdown
        const link =
          summary.getAttribute("data-href") || summary.getAttribute("href");
        if (link && link !== "#") {
          window.location.href = link;
        }
        e.preventDefault();
        e.stopPropagation();
      });

      // 监听下拉菜单内的鼠标事件
      submenu.addEventListener("mouseenter", () => {
        details.setAttribute("open", true);
        summary.setAttribute("aria-expanded", true);
      });

      submenu.addEventListener("mouseleave", () => {
        if (!menuItem.matches(":hover")) {
          details.removeAttribute("open");
          summary.setAttribute("aria-expanded", false);
        }
      });
    });
  }
});
